// extracted by mini-css-extract-plugin
export default {"dialogDescriptionWrap":"style_dialogDescriptionWrap__E0XaL","modalWrap":"style_modalWrap__j0Z41"};